define([
	'jquery',
	'pubsub',
	'shared.main.screen',
    'wcs.utils'
], function($,pubsub,screenSize,utils) {

	var PLUGIN_IDENTIFIER = "mainresize";
	var mainresize = function( element, options ) {
		this.element = element;
		this.options = options;
	};

	mainresize.prototype = {
		defaults: {
			currentSize: 'small',
			rateLimit: 150 // Limit how often event fires
		},

		init: function() {
			var self = this;
			
			// Merge the options and defaults into a config object
			self.config = $.extend( {}, self.defaults, self.options);

			// Calculate the current screen size, defaulting to small (always mobile-first!)
			self.config.currentSize = screenSize.size();

			self.events();

			return self;
		},

		/***
		 * Setup event handlers and event publishers
		 ***/
		events: function() {
			var self = this;

			self.initResizeEvents();
		},

		/**
		 * Setup a global pubsub event for window resizing
		 *
		 * Better performance - This reduces the number of
		 * window resize event listeners.
		 *
		 * Better performance - Reduce how often event fires
		 * while actively resizing by using a delay
		 *
		 * Setup a global pubsub event that fires only when the resize
		 * crosses a breakpoint.
		 *
		 * Publishes an event with new breakpoint in the name.
		 * Event data contains the previous breakpoint
		 *    data: { "was":"small", "now":"medium"}
		 * If a user resizes fast enough, they could jump from small to xlarge
		 * 
		 * Usage Examples:
		 * 
		 *    Listen for only entrance into the large breakpoint
		 *    $.pubsub('subscribe','window.resize.breakpoint.large',function(event,data) {
		 * 		  // runs whenever the large breakpoint is entered
		 *    });
		 * 
		 *    Listen for any breakpoint threshold
		 *    $.pubsub('subscribe','window.resize.breakpoint',function(event,data) {
		 * 		  // runs whenever the any breakpoint is entered
		 *    });
		 * 
		 *    Listen for any resize, even when it doesn't cross a threshold
		 *    $.pubsub('subscribe','window.resize',function(event,data) {
		 * 		  // runs for any resize, with the rate limiting in effect
		 *    });
		 **/
		initResizeEvents: function() {
			var self = this;

			// Setup rate limit on callback
			var callback = utils.debounce(function() {

				var newSize = screenSize.size(),
					data = {
						was: self.config.currentSize,
						now: newSize
					};
				// Check for crossing the threshold
				if(data.was === data.now) {
					$.pubsub('publish','window.resize'); // Intentionally not sending data here. Listeners should use the more specific events if they need breakpoints
				} else {
					$.pubsub('publish','window.resize.breakpoint.'+newSize, data);
					// Update stored size so we're ready for the next breakpoint
					self.config.currentSize = newSize;
				}

			},self.config.rateLimit);
			window.addEventListener('resize',callback);
		},

	};

	mainresize.defaults = mainresize.prototype.defaults;

	// prevent duplicate instantiation
	$.fn.mainresize = function(options) {
		return this.each(function() {
			var instance = $(this).data(PLUGIN_IDENTIFIER);
			if(!instance) {
				instance = new mainresize(this, options).init();
				$(this).data(PLUGIN_IDENTIFIER,instance);

				// attach to the window.main object for consistency
				window.main = window.main || {};
				window.main.resize = window.main.resize || instance;
			}
		});
	};

	// Initialize by attaching to the window object
	$(window).mainresize();
});